import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  Radio,
  Button,
  Switch,
} from "antd";
import { MSJOK, MSJERROR } from "../Alerts";
import {
  UpdatePersona,
  GetResidenteCodigo,
  UpdateCultura,
} from "../entity/helpers";
import styles from "./css/form.module.css";
import { SaveOutlined, SearchOutlined, EditOutlined } from "@ant-design/icons";
import {
  tipo_identificaciones,
  etnias,
  culturas,
  idiomas,
} from "../helpers/helperforms";
const { TextArea } = Input;

const { Option } = Select;

const Personas = () => {
  const cookies = new Cookies();
  if (typeof cookies.get("usuario") !== "undefined") {
    if (
      parseInt(cookies.get("usuario").hora_fin) <
      new Date()
        .getHours()
        .toLocaleString("es-ES", { timeZone: "America/Bogota" })
    )
      cookies.remove("usuario");
  }
  const formulario = cookies.get("formulario");
  var personas = cookies.get("personas2") ? cookies.get("personas2") : [];
  const [form_cultura, setFormCultura] = useState(formulario);
  const [idioma, setIdioma] = useState(idiomas[0]);
  const [idioma_bool, setIdiomaBool] = useState(-1);
  const [indigena_bool, setIndigenaBool] = useState(-1);
  const [edicion, setEdicion] = useState(false);
  const [n_orden_search, setNOrdenSearch] = useState(null);
  const [codigo, setCodigo] = useState(null);
  const [editBool, setEditBool] = useState(false);

  const handleSave = () => {
    UpdatePersona(form_cultura).then((res) => {
      if (res.config.data) {
        MSJOK("Datos guardados con exito.");
        personas = personas.filter(function (value, index, arr) {
          return value.id != form_cultura.n_orden;
        });
        cookies.remove("personas2");
        cookies.set("personas2", personas);
        setFormCultura(formulario);
        setIdiomaBool(-1);
        setIndigenaBool(-1);
      } else {
        MSJERROR(res.statusText);
      }
    });
  };

  const setLanguage = (e) => {
    const { name, value } = e.target;
    if (name !== "otro_idioma") setIdioma(value);
    setFormCultura({
      ...form_cultura,
      idioma: value,
    });
  };

  const handleUpdate = () => {
    UpdateCultura(form_cultura).then((res) => {
      if (res.data.message) {
        MSJOK(res.data.message);
        setEdicion(false);
        setFormCultura(formulario);
        setCodigo(null);
        setNOrdenSearch(null);
        setIdiomaBool(-1);
        setIndigenaBool(-1);
      } else {
        MSJERROR(res.data.error);
      }
    });
  };

  const handleSwitch = (e) => {
    setEditBool(e);
    setCodigo(null);
    setEdicion(false);
    setNOrdenSearch(null);
    setFormCultura(formulario);
    setIdiomaBool(-1);
    setIndigenaBool(-1);
  };

  const handleCodigo = (e) => {
    const { id, value } = e.target;
    setCodigo(value);
  };

  const handleOrden = (e) => {
    const { id, value } = e.target;
    setNOrdenSearch(value);
  };

  const handleSearch = () => {
    if (codigo && n_orden_search) {
      GetResidenteCodigo(codigo, n_orden_search).then((response) => {
        if (response[0]) {
          setFormCultura(response[0]);
          setEdicion(true);
          response[0].etnia ? setIndigenaBool(1) : setIndigenaBool(0);
          response[0].idioma ? setIdiomaBool(1) : setIdiomaBool(0);
        } else {
          setCodigo(null);
          setNOrdenSearch(null);
          setFormCultura(formulario);
          setIndigenaBool(0);
          setIdiomaBool(0);
          MSJERROR("No existe formulario con codigo: " + codigo);
        }
      });
    }
  };

  const radioIdioma = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setIdiomaBool(value);
    }
  };

  const radioIndigena = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setIndigenaBool(value);
    }
  };

  const handleClick = (e) => {
    const { name, value } = e.target;
    if (name === "indigena_bool") {
      if (value == indigena_bool) {
        setIndigenaBool(-1)
        setFormCultura({
          ...form_cultura,
          etnia: "",
        });
      }
    }
    if (name === "idioma_switch") {
      if (value == idioma_bool) {
        setIdiomaBool(-1)
        setFormCultura({
          ...form_cultura,
          idioma: "",
        });
      }
    }
    if (form_cultura) {
      if (value == form_cultura[name]) {
        setFormCultura({
          ...form_cultura,
          [name]: "",
        });
      }
    }
  };

  const handleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setFormCultura({
        ...form_cultura,
        [name]: value,
      });
    }
  };

  return (
    <>
      <Row gutter={24} justify="center">
        <Card
          title={
            <div>
              D.2. REGISTRO DE PERSONAS
              {"\n"}
              <>Desea editar?</>
              <Switch defaultChecked={editBool} onChange={handleSwitch} />
              <br></br>
              {editBool ? (
                <div>
                  <label>Buscar por: </label>
                  <Input
                    id="codigo"
                    placeholder={"Codigo formulario"}
                    onChange={handleCodigo}
                    value={codigo ? codigo : ""}
                    style={{ width: "20%" }}
                  />
                  <Input
                    id="n_orden"
                    placeholder={"# Orden"}
                    onChange={handleOrden}
                    value={n_orden_search ? n_orden_search : ""}
                    style={{ width: "10%" }}
                  />
                  <Button
                    type="primary"
                    disabled={codigo ? false : true}
                    shape="circle"
                    onClick={handleSearch}
                    icon={<SearchOutlined />}
                  />
                </div>
              ) : null}
            </div>
          }
          className={styles.cardDashboardgeneral}
          size="large"
        >
          <Row justify="center">
            <Form layout="vertical" initialValues={{ remember: true }}>
              {!editBool ? (
                <Form.Item label="Numero de Orden">
                  <select
                    className="ant-input"
                    name="n_orden"
                    onChange={handleChange}
                    value={
                      form_cultura
                        ? form_cultura.n_orden
                          ? form_cultura.n_orden
                          : ""
                        : ""
                    }
                    placeholder="Seleccione una opción"
                    defaultValue={0}
                  >
                    {personas.map((num) => {
                      return <option value={num.id}>{num.value}</option>;
                    })}
                  </select>
                </Form.Item>
              ) : null}

              <Form.Item label="6. Tipo de identificacion">
                <select
                  className="ant-input"
                  disabled={
                    form_cultura
                      ? form_cultura.n_orden > 0
                        ? false
                        : true
                      : true
                  }
                  name="tipo_identificacion"
                  onChange={handleChange}
                  value={
                    form_cultura
                      ? form_cultura.tipo_identificacion
                        ? form_cultura.tipo_identificacion
                        : ""
                      : ""
                  }
                  placeholder="Seleccione una opción"
                >
                  {tipo_identificaciones.map((tipo_identificacion) => {
                    return (
                      <option value={tipo_identificacion}>
                        {tipo_identificacion}
                      </option>
                    );
                  })}
                </select>
              </Form.Item>

              <Form.Item label="7. Numero de Identificacion">
                <Input
                  name="identificacion"
                  onChange={handleChange}
                  value={
                    form_cultura
                      ? form_cultura.identificacion
                        ? form_cultura.identificacion
                        : ""
                      : ""
                  }
                  disabled={
                    form_cultura
                      ? form_cultura.n_orden > 0
                        ? false
                        : true
                      : true
                  }
                />
              </Form.Item>

              <Form.Item label="8. De Acuerdo con su Cultura, pueblo o rasgos físicos, usted se reconoce como: ">
                <label>Indigena </label>
                <Radio.Group
                  name="indigena_bool"
                  defaultValue={
                    form_cultura ? (form_cultura.etnia ? 1 : 0) : indigena_bool
                  }
                  value={indigena_bool}
                  disabled={
                    form_cultura
                      ? form_cultura.n_orden > 0
                        ? false
                        : true
                      : true
                  }
                  onChange={radioIndigena}
                >
                  <Radio onClick={handleClick} value={1}>Si</Radio>
                  <Radio onClick={handleClick} value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
              {indigena_bool ? (
                <Form.Item label="">
                  <select
                    className="ant-input"
                    name="etnia"
                    onChange={handleChange}
                    value={
                      form_cultura
                        ? form_cultura.etnia
                          ? form_cultura.etnia
                          : ""
                        : ""
                    }
                    placeholder="Seleccione una opción"
                    disabled={
                      form_cultura
                        ? form_cultura.n_orden > 0
                          ? false
                          : true
                        : true
                    }
                  >
                    {etnias.map((etnia) => {
                      return <option value={etnia}>{etnia}</option>;
                    })}
                  </select>
                </Form.Item>
              ) : (
                <Form.Item label="9. De Acuerdo con su Cultura, pueblo o rasgos físicos, usted se reconoce como:">
                  <select
                    className="ant-input"
                    name="cultura"
                    onChange={handleChange}
                    value={
                      form_cultura
                        ? form_cultura.cultura
                          ? form_cultura.cultura
                          : ""
                        : ""
                    }
                    placeholder="Seleccione una opción"
                    disabled={
                      form_cultura
                        ? form_cultura.n_orden > 0
                          ? false
                          : true
                        : true
                    }
                  >
                    {culturas.map((cultura) => {
                      return <option value={cultura}>{cultura}</option>;
                    })}
                  </select>
                </Form.Item>
              )}

              <Form.Item label="10. Además de su lengua nativa,  domina otra  lengua o idioma:">
                <Radio.Group
                  name="idioma_switch"
                  defaultValue={
                    form_cultura ? (form_cultura.idioma ? 1 : 0) : idioma_bool
                  }
                  value={idioma_bool}
                  disabled={
                    form_cultura
                      ? form_cultura.n_orden > 0
                        ? false
                        : true
                      : true
                  }
                  onChange={radioIdioma}
                >
                  <Radio onClick={handleClick} value={1}>Si</Radio>
                  <Radio onClick={handleClick} value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
              {idioma_bool || editBool ? (
                <Form.Item label="">
                  <select
                    disabled={
                      form_cultura
                        ? form_cultura.n_orden > 0
                          ? false
                          : true
                        : true
                    }
                    className="ant-input"
                    name="idioma"
                    onChange={setLanguage}
                    value={
                      form_cultura
                        ? form_cultura.idioma
                          ? form_cultura.idioma
                          : ""
                        : ""
                    }
                    placeholder="Seleccione una opción"
                  >
                    {idiomas.map((value) => {
                      return <option value={value}>{value}</option>;
                    })}
                  </select>
                  {idioma === idiomas[idiomas.length - 1] ? (
                    <label>
                      Otro Idioma:{" "}
                      <Input name="otro_idioma" onChange={setLanguage} />
                    </label>
                  ) : null}
                </Form.Item>
              ) : null}

              <Form.Item justify="center">
                {editBool ? (
                  <>
                    <Button
                      style={
                        typeof cookies.get("usuario") !== "undefined"
                          ? edicion
                            ? { color: "white", backgroundColor: "green" }
                            : {}
                          : {}
                      }
                      disabled={
                        typeof cookies.get("usuario") !== "undefined"
                          ? edicion
                            ? false
                            : true
                          : true
                      }
                      icon={<EditOutlined />}
                      size="large"
                      shape="round"
                      onClick={handleUpdate}
                    >
                      Modificar
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      type="danger"
                      disabled={
                        form_cultura
                          ? parseInt(form_cultura.n_orden) > 0
                            ? false
                            : true
                          : true
                      }
                      icon={<SaveOutlined />}
                      size="large"
                      shape="round"
                      onClick={() => handleSave()}
                    >
                      Guardar
                    </Button>
                  </>
                )}
              </Form.Item>
            </Form>
          </Row>
        </Card>
      </Row>
    </>
  );
};

export default Personas;
